/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React, {
    useEffect, useCallback, useState, useContext
} from 'react';
// import _ from 'lodash';
import { Loader, Link } from '@jutro/components';
// import { TranslatorContext } from '@jutro/locale';
// import { useDependencies } from 'gw-portals-dependency-react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useDependencies } from 'gw-portals-dependency-react';
import { TermsAndConditionUtils } from 'gw-portals-util-js';
import {
    withApplicationPropertyContext
} from 'tdic-components-platform-react';
import { withRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-duplicates
import { useAuthentication } from 'gw-digital-auth-react';
import { TranslatorContext } from '@jutro/locale';
import { messages as commonMessages } from 'gw-platform-translations';
import metadata from './DeclarationPage.metadata.json5';
import styles from './DeclarationPage.module.scss';
import { _ } from 'core-js';
import { PolicyService } from 'gw-capability-policy';
import messages from './DeclarationPage.messages';

function DeclarationPage(props) {
    const {
 tncTransactionTypesSubTypes, termData: terms, onResolve, match    
} = props;
    const translator = useContext(TranslatorContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const { authHeader, user_name: userName, email: userEmail } = useAuthentication();
    const [isAcknowledged, setAcknowledgement] = useState(false);
    const [declarationPageDone, setDeclarationPageDone] = useState(false);
    const [isLoading, setLoadingState] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [documentDetails, updateDocumentDetails] = useState();
    const [offeringName, updateOfferingName] = useState('');
    const [showLoaderText, setShowLoaderText] = useState(false); // New state to control loader text visibility
    const policyNumber = _.get(match, 'params.policyNumber');
  
    useEffect(() => {
        setShowLoaderText(false); // Hide text for useEffect loader
        setLoadingState(true);
        const fetchPolicyDetails = async () => {
            try {
                const policyDetails = await PolicyService.getAccountPolicyDetails(policyNumber, authHeader);
                updateOfferingName(policyDetails.currentPeriod.offeringName);
                setLoadingState(false); // Corrected to match your state setter
            } catch (error) {
                setLoadingState(false); // Ensure loading stops on error
            }
        };
        fetchPolicyDetails();
    }, [authHeader, policyNumber]); 

   const checkDocumentDetails = useCallback(async (changeJobNumber) => {
    try {
        const docDetails = await EndorsementService.getDocumentDetails(
            changeJobNumber,
            authHeader
        );
       const docUID = _.get(docDetails, 'docUID', 'none');
        if (docUID !== 'none') {
           // Document is ready, move to next screen
            updateDocumentDetails(docDetails);
            
            // Sequential promise-based calls
            EndorsementService.sendDeclarationEmail(changeJobNumber, authHeader)
                .then(() => {
                    // After email is sent, save T&C
                    return TermsAndConditionUtils.saveTnCAcceptance(
                        _.get(terms, 'Version', ''),
                        tncTransactionTypesSubTypes,
                        'PolicyChange',
                        'RegenerateDeclaration',
                        authHeader,
                        docDetails.jobNumber,
                        userName,
                        userEmail
                    );
                })
                .then(() => {
                    setErrorState(false);
                    setDeclarationPageDone(true);
                    setLoadingState(false);
                })
                .catch(() => {
                    // Handle errors from either call
                    setErrorState(true);
                    setLoadingState(false);
                });
        } else {
            // Still 'none', retry after 0.5 minute
            setTimeout(() => checkDocumentDetails(changeJobNumber), 30000);
        }
    } catch (error) {
        setErrorState(true);
        setLoadingState(false);
    }
}, [EndorsementService, authHeader, terms, tncTransactionTypesSubTypes, userName, userEmail]);

    const handleSubmit = useCallback(async () => {
        if (!declarationPageDone) {
            try {
                setShowLoaderText(true); // Show text for submit loader
                setLoadingState(true);
                // First call — performDecPageChange
                const changeJobNumber = await EndorsementService.performDecPageChange(
                    policyNumber,
                    authHeader
                );
                if (changeJobNumber) {
                    updateDocumentDetails(changeJobNumber);
                    // Start checking document details
                    checkDocumentDetails(changeJobNumber);
                } else {
                    setErrorState(true);
                    setLoadingState(false);
                }
            } catch (error) {
                setDeclarationPageDone(false);
                setErrorState(true);
                setLoadingState(false);
            }
        } else {
            onResolve();
        }
    }, [declarationPageDone, EndorsementService, policyNumber, authHeader, checkDocumentDetails, onResolve]);

    const handleBack = useCallback(() => {
        const { history } = props;
        const redirectPath = '/home';
        history.push(redirectPath);
    }, [props]);

    const getDownloadLink = useCallback((document) => {
        const { publicID, sessionID } = document;
        PolicyService.downloadDocumentLink(publicID, sessionID)
            .then((response) => {
                if (response.ok) {
                    response.text().then((text) => {
                        const docWin = window.open('', '_blank');
                        docWin.document.write(text);
                    });
                } else {
                    ModalNextProvider.showAlert({
                        title: messages.viewDownload,
                        message: messages.downloadErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).then(_.noop);
                }
            });
    }, []);

       const renderDocument = useCallback((document) => {
        const docName = _.get(document, 'name');
        if (_.get(document, 'docUID', 'none') !== 'none') {
            return (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <Link onClick={() => {
                    getDownloadLink(document); // Trigger download
                }}
                >
                    {docName}
                </Link>
            );
        }
        return null;
    }, [getDownloadLink]);

      if (isLoading) {
          return <Loader loaded={!isLoading} text={showLoaderText ? translator(messages.loaderText) : null} />;
        }

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        termsAndConditionsCheckbox: {
            value: isAcknowledged,
            onValueChange: setAcknowledgement
        },
        declarationPageRadioButton: {
            value: true
        },
        declarationPageErrorDiv: {
            visible: errorState
        },
        declarationPageConfirmationDiv: {
            visible: declarationPageDone && !errorState
        },
        declarationPageContainerDiv: {
            visible: !declarationPageDone
        },
        submitBtnId: {
            disabled: !isAcknowledged
        },
        documentLink: {
            content: renderDocument(documentDetails)
        },
        declarationPageHeaderId: {
            content: offeringName ? `${offeringName} (${policyNumber})` : `Loading...(${policyNumber})`
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleSubmit,
            handleBack
        }
    };
    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default withRouter(
    withApplicationPropertyContext(DeclarationPage)
);
